import axios from 'axios';
import { getApiBaseUrl } from 'shared/helpers/env';

export const validateMessage = async ({
  scene,
  contentType,
  content,
  conversationId,
  inboxId
}) => {
  try {
    const response = await axios.post(getApiBaseUrl() + '/n/api/buyer/cs/aichat/message/preCheck', {
      scene,
      contentType,
      content,
      conversationId,
      inboxId
    });
    if (response.data.ret !== 200) {
      throw new Error(response.data.msg);
    }
    return response.data;
  } catch (error) {
    console.error('Error validating message:', error);
    // In case of error, return a safe default
    return {
      requireReconfirm: false,
      isGoodToSend: true,
      popupTips: '',
      content: '',
    };
  }
};
